import administracao from './administracao'
import autenticacao from './autenticacao'
import cadastro from './cadastro'
import integracao from './integracao'
import perfil from './perfil'

const baseApiUrl = `/api`

export default {
    administracao: administracao(baseApiUrl),
    autenticacao: autenticacao(baseApiUrl),
    cadastro: cadastro(baseApiUrl),
    integracao: integracao(baseApiUrl),
    perfil: perfil(baseApiUrl),
}